import { ApiClient } from "./clients";
import { Page } from "./models/page/Page";

export class PageProvider {
  constructor(private readonly apiClient: ApiClient) {}

  async getOneBySlug(slug: string): Promise<Page | null> {
    const data = await this.apiClient.get(`/${encodeURIComponent(slug)}`);
    // cabinet-api answers an unknown slug with 200 and an empty body
    return data && data.slug ? data : null;
  }
}
